<template>
  <div :class="`tw-conf--${brand}`">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import fonts from '@dahl-js/dahl-ui/styles/vars/fonts.js';
import { useServerStore, useContentStore } from '@/stores';

const serverStore = useServerStore();

const {
  public: { brand },
} = useRuntimeConfig();

await useAsyncData(async () => await serverStore.serverInit(brand));

const { fetchAlertBanner } = useContentStore();
await fetchAlertBanner();

const fontLinks = fonts[brand].flatMap(({ url }) => [
  {
    rel: 'preload',
    as: 'style',
    href: url,
  },
  {
    rel: 'stylesheet',
    href: url,
  },
]);

useHead({
  link: [
    {
      type: 'text/css',
      rel: 'stylesheet',
      href: `/${brand}.css`,
    },
    ...fontLinks,
  ],
});
</script>
